import { useRouterState } from "@tanstack/react-router";
import { selectActiveRoute } from "./metadata";

export function useActiveRoute() {
  const matches = useRouterState({ select: (state) => state.matches });
  return selectActiveRoute(matches);
}
